import React, { useRef, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { format, parseISO } from 'date-fns';
import { isEmpty } from 'lodash';

import { Input } from '~/components/Form';
import { Shifts } from '~/componentslocal';
import { Report, UnidataTable, Modal } from '~/components';
import { recordFiltering } from '~/store/modules/abastecimentoA2VF/actions';
import { number } from '~/helpers';

import Details from './Details';
import * as S from './styles';

export default function DlgRelAbastecimentocomA2vf() {
  const formRef = useRef(null);
  const mRef = useRef(null);

  const dataRedux = useSelector((state) => state.abastecimentoA2VF);

  const title = useMemo(() => 'Relatório de Abastecimento com A2VF', []);
  const initialData = useMemo(
    () => ({
      datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );
  const header = useMemo(
    () => [
      {
        id: 'abas_datahora_fim',
        label: 'Data',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:MM:ss'),
      },
      { id: 'post_desc', label: 'Posto', align: 'center' },
      { id: 'veic_cod_veic', label: 'Locomotiva', align: 'center' },
      { id: 'bico_cod_bico', label: 'Bico', align: 'center' },
      {
        id: 'abas_volume',
        label: 'Volume',
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'abas_dloc_atuado_status_str',
        label: 'Ident. Locomotiva',
        align: 'center',
      },
      {
        id: 'abas_dbic_atuado_status_str',
        label: 'Ident. Locomotiva',
        align: 'center',
      },
      {
        id: 'abas_overfillatuou_str',
        label: 'Lib. Util. Overfill',
        align: 'center',
      },
      {
        id: 'abas_liberado_com_homem_morto_str',
        label: 'Lib. Util. Homem-Morto',
        align: 'center',
      },
      {
        id: 'abas_numero_serie_dloc',
        label: 'DLOC #Séries',
        align: 'center',
      },
      {
        id: 'abas_versao_firmware_dloc',
        label: 'DLOC Ver.FW',
        align: 'center',
      },
      {
        id: 'abas_data_compilacao_dloc',
        label: 'DLOC Comp. Data',
        align: 'center',
      },
      {
        id: 'abas_hora_compilacao_dloc',
        label: 'DLOC Comp. Hora',
        align: 'center',
      },
      {
        id: 'abas_overfillatuou_str',
        label: 'Overfill Atuou',
        align: 'center',
      },
      {
        id: 'abas_overfillatlersennivdloc_str',
        label: 'Status Overfill Final',
        align: 'center',
      },
    ],
    []
  );

  const [open, setOpen] = useState(true);
  const [toolbar, setToolbar] = useState({});
  const [query, setQuery] = useState({});
  const [grid, setGrid] = useState(false);

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleSerializeData = useCallback(
    (data) => {
      const { veic_cod_veic } = data;
      const { initial, final, tank } = toolbar;

      const wherefield = ['datahorainicial', 'datahorafinal'];
      const valuewherefield = [initial, final];
      const typewherefield = ['MAIOR_IGUAL', 'MENOR_IGUAL'];

      if (veic_cod_veic) {
        wherefield.push('veic_cod_veic');
        valuewherefield.push(veic_cod_veic);
        typewherefield.push('EQUALS');
      }

      if (tank) {
        wherefield.push('post_cod_posto');
        valuewherefield.push(tank);
        typewherefield.push('EQUALS');
      }

      setToolbar((state) => ({ ...state, locomotive: veic_cod_veic }));
      setGrid(true);
      setQuery({
        wherefield,
        valuewherefield,
        typewherefield,
      });

      return undefined;
    },
    [toolbar]
  );

  const handleToggleOpenDetails = useCallback((data) => {
    if (!isEmpty(data)) mRef.current.handleOpenModal({ data });
  }, []);

  if (grid && !isEmpty(query))
    return (
      <>
        <S.HeaderWrapper>
          <li>
            <span>Data Emissão:</span> {toolbar.issuance_date}
          </li>

          <li>
            <span>Período:</span> {toolbar.period}
          </li>

          <li>
            <span>Emissor:</span> {toolbar.emitter}
          </li>
          <li>
            <span>Posto:</span> {toolbar.station}
          </li>

          <li>
            <span>Locomotiva:</span> {toolbar.locomotive}
          </li>
        </S.HeaderWrapper>

        <UnidataTable
          fixed
          header={header}
          read={recordFiltering}
          redux={dataRedux}
          title={title}
          query={query}
          onRow={handleToggleOpenDetails}
          keys={['rownum']}
          detach="desc_num_doc"
          maxHeight="calc(100vh - 36rem)"
          create={false}
          update={false}
          delete={false}
        />

        <Modal
          disableBackdropClick
          disableEscapeKeyDown
          ref={mRef}
          title={`${title} - Detalhe`}
          component={Details}
          actions={[
            {
              label: 'Fechar',
              color: 'secondary',
              autoFocus: true,
              callback: () => mRef.current.handleCloseModal(),
            },
          ]}
        />
      </>
    );

  return (
    <Report
      ref={formRef}
      open={open}
      title={title}
      initials={initialData}
      relatorio=""
      onClose={handleCloseReport}
      serialize={handleSerializeData}
    >
      <Shifts forms={formRef} onToolbar={(value) => setToolbar(value)} />

      <Input name="veic_cod_veic" label="Locomotiva" />
    </Report>
  );
}
